(function () {
  'use strict';

  var TARGET_SELECTOR = '[data-pdp-deferred-alpine][x-ignore]';
  var ROOT_MARGIN = '900px 0px';
  var initialized = false;

  function hydrate(target) {
    if (!target || !target.hasAttribute('x-ignore')) return;

    target.removeAttribute('x-ignore');
    target.removeAttribute('data-pdp-deferred-alpine');

    if (window.Alpine && typeof window.Alpine.initTree === 'function') {
      window.Alpine.initTree(target);
    }
  }

  function initDeferredAlpine() {
    var targets = Array.prototype.slice.call(document.querySelectorAll(TARGET_SELECTOR));
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(hydrate);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        hydrate(entry.target);
      });
    }, { rootMargin: ROOT_MARGIN });

    targets.forEach(function (target) {
      observer.observe(target);

      target.addEventListener('focusin', function () {
        observer.unobserve(target);
        hydrate(target);
      }, { once: true });

      target.addEventListener('mouseover', function () {
        observer.unobserve(target);
        hydrate(target);
      }, { once: true, passive: true });

      target.addEventListener('touchstart', function () {
        observer.unobserve(target);
        hydrate(target);
      }, { once: true, passive: true });
    });
  }

  function initWhenAlpineReady() {
    if (initialized || !window.Alpine || typeof window.Alpine.initTree !== 'function') return;
    initialized = true;
    initDeferredAlpine();
  }

  document.addEventListener('alpine:initialized', initWhenAlpineReady, { once: true });
  window.setTimeout(initWhenAlpineReady, 0);
  window.addEventListener('load', initWhenAlpineReady, { once: true });

  window.addEventListener('satellai:pdp-deferred-section-loaded', function (event) {
    var target = event.detail && event.detail.target;
    if (!target) return;

    Array.prototype.slice.call(target.querySelectorAll(TARGET_SELECTOR)).forEach(hydrate);
  });
})();
